const failedChunkKey = 'maxed:failed-dynamic-import';

type PreloadErrorEvent = Event & { payload?: unknown };
type SessionStorage = Pick<Storage, 'getItem' | 'setItem'>;

function errorFingerprint(payload: unknown) {
  if (payload && typeof payload === 'object' && 'message' in payload) {
    const message = (payload as { message?: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  return String(payload || 'unknown dynamic import failure');
}

export function recoverFromStaleChunk(
  event: PreloadErrorEvent,
  storage: SessionStorage,
  reload: () => void,
) {
  const fingerprint = errorFingerprint(event.payload);

  // A newly deployed Vite build gives lazy chunks new content-hashed names. An
  // already-open tab can therefore request a chunk that no longer exists. Give
  // each distinct failed import one automatic refresh, but never create a loop
  // if refreshing cannot resolve the failure.
  if (storage.getItem(failedChunkKey) === fingerprint) return false;

  storage.setItem(failedChunkKey, fingerprint);
  event.preventDefault();
  reload();
  return true;
}

export function installChunkRecovery() {
  window.addEventListener('vite:preloadError', (event) => {
    try {
      recoverFromStaleChunk(
        event as PreloadErrorEvent,
        window.sessionStorage,
        () => window.location.reload(),
      );
    } catch {
      // If session storage is unavailable, leave Vite's original error intact
      // instead of risking an unbounded reload loop.
    }
  });
}
